import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';

// デフォルトアイコンのバグ回避設定
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

// 地図の中心を動かすカスタムコンポーネント
function ChangeMapCenter({ center }) {
  const map = useMap();
  useEffect(() => {
    if (center) {
      map.setView(center, 15);
    }
  }, [center, map]);
  return null;
}

function App() {
  const [position, setPosition] = useState([35.681, 139.767]);
  const [errorMsg, setErrorMsg] = useState(null);

  // 📝 追加：フォーム用の状態管理
  const [username, setUsername] = useState('');
  const [message, setMessage] = useState('');

  // 📌 追加：DBから取得したすべての投稿を保存する配列
  const [posts, setPosts] = useState([]);

  // 🌍 現在地を取得する関数
  const handleGetLocation = () => {
    if (!navigator.geolocation) {
      setErrorMsg('お使いのブラウザは位置情報に対応していません。');
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (success) => {
        setPosition([success.coords.latitude, success.coords.longitude]);
        setErrorMsg(null);
      },
      (error) => {
        setErrorMsg('位置情報の取得に失敗しました。利用を許可してください。');
      },
      { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
    );
  };

  // 📥 【API連携: GET】JavaのAPIから全投稿データを取得する関数
  const fetchPosts = async () => {
    try {
      const response = await fetch('/api/posts');
      if (!response.ok) throw new Error('データの取得に失敗しました');
      const data = await response.json();
      setPosts(data); // 取得したデータを状態にセット
    } catch (error) {
      console.error('API接続エラー:', error);
    }
  };

  // 📤 【API連携: POST】入力したデータをJavaのAPIへ送信する関数
  const handleSubmit = async (e) => {
    e.preventDefault(); // 画面のリロードを防ぐ
    if (!username || !message) {
      alert('名前とメッセージを入力してください');
      return;
    }

    const newPost = {
      username: username,
      message: message,
      latitude: position[0],
      longitude: position[1]
    };

    try {
      const response = await fetch('/api/posts', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newPost) // UTF-8形式でJSON送信
      });

      if (response.ok) {
        setMessage(''); // 投稿が成功したらメッセージ欄を空にする
        fetchPosts();   // 地図上のピンを最新の状態に更新する
        alert('位置情報を投稿しました！');
      } else {
        alert('投稿に失敗しました。');
      }
    } catch (error) {
      console.error('送信エラー:', error);
      alert('サーバーに接続できませんでした。');
    }
  };

  // 画面を開いた時に「現在地取得」と「過去データ取得」を同時に行う
  useEffect(() => {
    handleGetLocation();
    fetchPosts();
  }, []);

  return (
    <div style={{ padding: '20px', fontFamily: 'sans-serif', maxWidth: '800px', margin: '0 auto' }}>
      <h1>🗺️ 位置情報 SNS (React ⇄ Java)</h1>
      
      {/* エラー表示 */}
      {errorMsg && <p style={{ color: 'red' }}>{errorMsg}</p>}

      {/* 地図表示エリア */}
      <MapContainer center={position} zoom={13} style={{ height: '400px', width: '100%', borderRadius: '8px', marginBottom: '20px' }}>
        <TileLayer
          attribution='&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        
        {/* 📌 DBから取得したすべての投稿を地図上に展開する */}
        {posts.map((post) => (
          <Marker key={post.id} position={[post.latitude, post.longitude]}>
            <Popup>
              <strong>{post.username}</strong><br />
              {post.message}<br />
              <small style={{ color: '#888' }}>{new Date(post.createdAt).toLocaleString()}</small>
            </Popup>
          </Marker>
        ))}

        <ChangeMapCenter center={position} />
      </MapContainer>

      {/* 📝 新規投稿用フォーム */}
      <form onSubmit={handleSubmit} style={{ backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '8px' }}>
        <h3>📍 現在地にメッセージを投稿する</h3>
        <p style={{ fontSize: '14px', color: '#555' }}>
          送信座標: 緯度 {position[0].toFixed(4)} / 経度 {position[1].toFixed(4)}
        </p>
        
        <div style={{ marginBottom: '10px' }}>
          <label style={{ display: 'block', marginBottom: '5px' }}>名前:</label>
          <input 
            type="text" 
            value={username} 
            onChange={(e) => setUsername(e.target.value)}
            style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
            placeholder="ニックネーム"
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px' }}>メッセージ:</label>
          <textarea 
            value={message} 
            onChange={(e) => setMessage(e.target.value)}
            style={{ width: '100%', padding: '8px', boxSizing: 'border-box', height: '60px' }}
            placeholder="今どこで何してる？"
          />
        </div>

        <button type="submit" style={{ padding: '10px 20px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '16px' }}>
          この場所に投稿する
        </button>
      </form>
    </div>
  );
}

export default App;